const state = {
    itens: [],
    item: {
        name: ''
    }
};

export default state;